import { render, staticRenderFns } from "./usInNumbers.vue?vue&type=template&id=1d620896"
import script from "./usInNumbers.vue?vue&type=script&lang=ts"
export * from "./usInNumbers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports